<template>
  <div class="loading-screen" :class="{ 'fade-out': isLoaded }">
    <div class="loading-content">
      <div class="loading-logo">
        <img src="../assets/logo.png" alt="FM Logo">
      </div>
      <div class="loading-spinner">
        <div class="spinner-circle"></div>
        <div class="spinner-circle"></div>
        <div class="spinner-circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  props: {
    isLoaded: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.5s ease, visibility 0.5s ease;
}

.loading-screen.fade-out {
  opacity: 0;
  visibility: hidden;
}

.loading-content {
  text-align: center;
}

.loading-logo {
  margin-bottom: 30px;
}

.loading-logo img {
  height: 60px;
  animation: pulse 2s infinite;
}

.loading-spinner {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.spinner-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #FF7A59;
  animation: bounce 0.5s infinite alternate;
}

.spinner-circle:nth-child(2) {
  animation-delay: 0.1s;
  background: #FF9E7A;
}

.spinner-circle:nth-child(3) {
  animation-delay: 0.2s;
  background: #FFC1A6;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}
</style> 